/** True on Chrome/Edge/Opera; false on Safari/Firefox. */
export function supportsFileSystemAccess(): boolean {
  return "showSaveFilePicker" in window;
}

/** Write bytes to a previously-obtained FileSystemFileHandle (silent save). */
export async function saveToHandle(
  handle: FileSystemFileHandle,
  bytes: Uint8Array,
): Promise<void> {
  const writable = await handle.createWritable();
  await writable.write(bytes);
  await writable.close();
}

/** Trigger a browser download with the given filename. Works in all modern browsers. */
export function triggerDownload(bytes: Uint8Array, filename: string): void {
  const blob = new Blob([bytes], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  // Defer revocation: some browsers (Firefox, Safari) fetch the blob asynchronously
  // after click. Revoking synchronously can cause silent download failures.
  // 60 seconds is well beyond any reasonable browser fetch delay.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
